function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Tooltip from "./ChartTooltip";

import { FormatMetric, FormatDimension } from "../";

var TooltipCompare = function (_Component) {
    _inherits(TooltipCompare, _Component);

    function TooltipCompare() {
        var _temp, _this, _ret;

        _classCallCheck(this, TooltipCompare);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderSingle = function () {
            var _this$props = _this.props,
                slice = _this$props.slice,
                metric = _this$props.metric,
                dimension = _this$props.dimension;


            var series = slice.points;
            var s1 = series[0].data || undefined;

            var metricType = s1.metricType,
                x = s1.x,
                y = s1.y,
                datetime = s1.datetime;


            var d = void 0;

            if (dimension.startsWith('ga:nth')) {
                d = datetime;
            } else {
                d = x;
            }

            return React.createElement(
                Tooltip,
                null,
                React.createElement(
                    "h2",
                    { className: "admin-tooltip__title" },
                    React.createElement(FormatDimension, { name: dimension, value: d })
                ),
                React.createElement(
                    "h3",
                    { className: "admin-tooltip__value" },
                    React.createElement(FormatMetric, { type: metricType, value: y })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    TooltipCompare.prototype.render = function render() {
        var _props = this.props,
            slice = _props.slice,
            metric = _props.metric,
            dimension = _props.dimension;


        var series = slice.points;

        var s1 = series[1].data || undefined;
        var s2 = series[0].data;

        if (s1 && !s2) {
            return this.renderSingle(s2);
        }

        var change = void 0,
            trending = void 0;

        if (s1.value > s2.value) {
            change = (s1.value - s2.value) / s1.value * 100;
            trending = "up";
        } else if (s2.value > s1.value) {
            change = (s2.value - s1.value) / s2.value * 100;
            trending = "down";
        } else {
            change = 0;
            trending = "flat";
        }

        if (dimension.startsWith('ga:nth')) {
            s1.d = s1.datetime;
            s2.d = s2.datetime;
        } else {
            s1.d = s1.x;
            s2.d = s2.x;
        }

        return React.createElement(
            Tooltip,
            null,
            React.createElement(
                "h2",
                { className: "admin-tooltip__title" },
                React.createElement(FormatDimension, { name: dimension, value: [s1.d, s2.d] })
            ),
            React.createElement(
                "h3",
                { className: "admin-tooltip__value" },
                React.createElement(FormatMetric, { id: s1.metric, type: s1.metricType, value: s1.y })
            ),
            React.createElement(
                "p",
                { className: "admin-tooltip__change", "data-trending": trending },
                React.createElement(FormatMetric, { type: "PERCENT", value: change })
            )
        );
    };

    return TooltipCompare;
}(Component);

export default TooltipCompare;